import React from 'react';
import { Col, Divider, Empty, Row, Spin, Table, Typography } from 'antd';
import { OppLineItem } from '@cbinsights/salesforceservice/salesforceservice';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useGetOpLineItemsQuery } from '../../services/hooks/useGetOpLineItems';

type Props = {
  accountId: string;
};

const formatDate = (date: string) =>
  date ? moment(date).format('MM-DD-YYYY') : '-';

const lineItemColumns: ColumnsType<OppLineItem> = [
  {
    title: 'Product Code',
    dataIndex: 'productCode',
    key: 'productCode',
    width: '33%',
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
    width: '33%',
    render: formatDate,
  },
  {
    title: 'End Date',
    dataIndex: 'endDate',
    key: 'endDate',
    width: '33%',
    render: formatDate,
  },
];

const SFOportunity = ({ accountId }: Props) => {
  const { data: opLineItems, isLoading } = useGetOpLineItemsQuery({
    enabled: !!accountId,
    params: { accountId },
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <Spin tip="Loading opportunities..." />
      </div>
    );
  }

  if (!opLineItems?.lineItems?.length) {
    return <Empty description="No active opportunities found." />;
  }

  const byOpportunity = opLineItems.lineItems.reduce<
    Record<string, OppLineItem[]>
  >((acc, item) => {
    if (!acc[item.oppId]) acc[item.oppId] = [];
    acc[item.oppId].push(item);
    return acc;
  }, {});

  return (
    <div>
      {Object.entries(byOpportunity).map(([oppId, items]) => (
        <div key={oppId} className="mb-8">
          <Row align="middle" gutter={8} className="mb-1">
            <Col>
              <Typography.Title level={5} className="!mb-0 !font-medium">
                Opportunity ID: {oppId}
              </Typography.Title>
            </Col>
          </Row>
          <Divider className="border-t border-gray-300 border-solid !mt-1 !mb-3" />
          <Table
            bordered
            size="small"
            columns={lineItemColumns}
            dataSource={items}
            pagination={false}
            rowKey={(row) => `${oppId}-${row.productCode}`}
            tableLayout="fixed"
          />
        </div>
      ))}
    </div>
  );
};

export default SFOportunity;
